import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Homepage from "./pages/Homepage";
import AboutPage from "./pages/AboutPage";
import HowItWorksPage from "./pages/HowItWorksPage";
import ContactPage from "./pages/ContactPage";
import SignupPage from "./pages/SignupPage";
import LoginPage from "./pages/LoginPage";
import ApplicantDashboard from "./pages/ApplicantDashboard";
import PublicVideoPage from "./pages/PublicVideoPage";
import SonicLogoCompare from "./pages/SonicLogoCompare";
import EmployersPage from "./pages/EmployersPage";
import EmployerIntakePage from "./pages/EmployerIntakePage";
import EmployerIntakeSuccessPage from "./pages/EmployerIntakeSuccessPage";
import EmployerPaySuccessPage from "./pages/EmployerPaySuccessPage";
import EmployerPayCancelPage from "./pages/EmployerPayCancelPage";
import { EmployerProtectedRoute } from "./components/hub/EmployerProtectedRoute";
import EmployerHubOverview from "./pages/hub/EmployerHubOverview";
import EmployerHubCandidates from "./pages/hub/EmployerHubCandidates";
import EmployerHubCandidateReview from "./pages/hub/EmployerHubCandidateReview";
import EmployerHubInterviews from "./pages/hub/EmployerHubInterviews";
import EmployerHubBilling from "./pages/hub/EmployerHubBilling";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { BetaRibbon } from "./components/BetaRibbon";

/**
 * Global layout wrapper. Renders the BETA ribbon ONLY on the
 * authenticated applicant dashboard. We hide it on every public-
 * facing route (homepage, about, how-it-works, contact, login,
 * signup) and on the recruiter-facing /video/:userId page so the
 * pitch surfaces feel finished. Beta context still reaches the
 * applicant once they're signed in, which is where it's actually
 * useful.
 */
function GlobalLayout({ children }) {
  const location = useLocation();
  const showBetaRibbon = location.pathname.startsWith("/dashboard");
  return (
    <>
      {showBetaRibbon && <BetaRibbon />}
      {children}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <GlobalLayout>
            <Routes>
              <Route path="/" element={<Homepage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/how-it-works" element={<HowItWorksPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/dashboard/applicant" element={<ApplicantDashboard />} />
              <Route path="/video/:userId" element={<PublicVideoPage />} />
              <Route path="/video/:userId/p/:packageId" element={<PublicVideoPage />} />
              <Route path="/branding/sonic-logo" element={<SonicLogoCompare />} />
              {/* Inter-View Employer Experience — Phase 1A */}
              <Route path="/employers" element={<EmployersPage />} />
              <Route path="/employers/intake" element={<EmployerIntakePage />} />
              <Route path="/employers/intake/success" element={<EmployerIntakeSuccessPage />} />
              {/* Phase 1B — direct purchase return pages */}
              <Route path="/employers/purchase/success" element={<EmployerPaySuccessPage />} />
              <Route path="/employers/purchase/cancel" element={<EmployerPayCancelPage />} />
              {/* Employer Hub — Gate 2 (role-protected workspace) */}
              <Route path="/employers/hub" element={<EmployerProtectedRoute><EmployerHubOverview /></EmployerProtectedRoute>} />
              <Route path="/employers/hub/candidates" element={<EmployerProtectedRoute><EmployerHubCandidates /></EmployerProtectedRoute>} />
              <Route path="/employers/hub/candidates/:assignmentId" element={<EmployerProtectedRoute><EmployerHubCandidateReview /></EmployerProtectedRoute>} />
              <Route path="/employers/hub/interviews" element={<EmployerProtectedRoute><EmployerHubInterviews /></EmployerProtectedRoute>} />
              <Route path="/employers/hub/billing" element={<EmployerProtectedRoute><EmployerHubBilling /></EmployerProtectedRoute>} />
              <Route path="/verify-email" element={<VerifyEmailPage />} />
            </Routes>
          </GlobalLayout>
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;